import { Trans } from 'react-i18next';
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import MainBlockLayout from '../../components/MainBlockLayout';
import './SchoolPolicies.css';

import Anti_bullying_policy from '../../files/Anti_bullying_policy.pdf';
import Complaint_policies_new from '../../files/Complaint_policies_new.pdf';
import Health_and_Safety_Policy from '../../files/Health_and_Safety_Policy.pdf';
import asthma_policy_2026 from '../../files/Asthma_Policy_2025-26.pdf';
import data_protection_parents_policy_2026 from '../../files/Data_protection_parents_2026.pdf';
import E_Safety_policy_2026 from '../../files/E_Safety_policy_2026.pdf';
import equality_and_diversity_policy_2026 from '../../files/equality-and-diversity_2026.pdf';
import First_Aid_policy_2026 from '../../files/First_Aid_Policy_2025-26.pdf';
import GDPR_policy_2026 from '../../files/GDPR_policy_2026.pdf';
import HR_policy_2026 from '../../files/HR_Policies_for_recruiting_St Marys_2026.pdf';
import safeguarding_children_policy_2026 from '../../files/safeguarding_children_child_protection_policy_2026.pdf';
import Specimen_Parent_Asthma_Letter_2026 from '../../files/Specimen_Parent_Asthma_Letter_2026.pdf';
import Staff_code_of_conduct_2026 from '../../files/Staff_code_of_conduct_2026.pdf';
import Whistleblowing_policy_2026 from '../../files/Whistleblowing_Policy.pdf';
import terms_and_conditions from '../../files/UpshotTermsandConditions.pdf';

/*
  HOW TO EDIT THIS PAGE
  - Categories and policies are shown in the order listed here (most important first).
  - To add a policy: import the PDF above, then add { titleKey, year, file } to a category.
  - titleKey is a translation key (the English title). Add it to the translation files
    if you want a Ukrainian title; otherwise the English text is shown.
  - To add a category: add a new object with an id, an icon and a titleKey (also a translation key).
*/
const CATEGORIES = [
  {
    id: 'safeguarding',
    icon: '🛡️',
    titleKey: 'policy_cat_safeguarding',
    policies: [
      { titleKey: 'Safeguarding Children - Child Protection Policies', year: 2026, file: safeguarding_children_policy_2026 },
      { titleKey: 'Anti-bullying Policies', year: 2026, file: Anti_bullying_policy },
      { titleKey: 'E-Safety Policies', year: 2026, file: E_Safety_policy_2026 },
      { titleKey: 'Equality and Diversity Policies', year: 2026, file: equality_and_diversity_policy_2026 },
    ],
  },
  {
    id: 'health',
    icon: '⚕️',
    titleKey: 'policy_cat_health',
    policies: [
      { titleKey: 'Health and Safety Policies', year: 2026, file: Health_and_Safety_Policy },
      { titleKey: 'First Aid Policies', year: 2026, file: First_Aid_policy_2026 },
      { titleKey: 'Asthma Policies', year: 2026, file: asthma_policy_2026 },
      { titleKey: 'Specimen Parent Asthma Letter', year: 2026, file: Specimen_Parent_Asthma_Letter_2026 },
    ],
  },
  {
    id: 'data',
    icon: '🔒',
    titleKey: 'policy_cat_data',
    policies: [
      { titleKey: 'GDPR Policies', year: 2026, file: GDPR_policy_2026 },
      { titleKey: 'Data Protection for Parents Policies', year: 2026, file: data_protection_parents_policy_2026 },
    ],
  },
  {
    id: 'staff',
    icon: '👩‍🏫',
    titleKey: 'policy_cat_staff',
    policies: [
      { titleKey: 'Staff Code of Conduct', year: 2026, file: Staff_code_of_conduct_2026 },
      { titleKey: 'HR Policies for Recruiting', year: 2026, file: HR_policy_2026 },
      { titleKey: 'Whistleblowing Policies', year: 2026, file: Whistleblowing_policy_2026 },
    ],
  },
  {
    id: 'parents',
    icon: '📋',
    titleKey: 'policy_cat_parents',
    policies: [
      { titleKey: 'Complaint Policies', year: 2026, file: Complaint_policies_new },
      { titleKey: 'Terms and Conditions', year: 2026, file: terms_and_conditions },
    ],
  },
];

function MainBlock() {
  // The policy currently open in the full-screen preview (null = closed)
  const [activeDoc, setActiveDoc] = useState(null);

  return (
    <div className="policiesPage">
      <div className="policiesHero">
        <h2><Trans i18nKey="School policies" /></h2>
        <p><Trans i18nKey="policies_intro" /></p>
      </div>

      {/* Quick jump links to each category */}
      <div className="policiesJump">
        {CATEGORIES.map((cat) => (
          <a key={cat.id} href={`#policy-${cat.id}`}>
            {cat.icon} <Trans i18nKey={cat.titleKey} />
          </a>
        ))}
      </div>

      {CATEGORIES.map((cat) => (
        <section key={cat.id} id={`policy-${cat.id}`} className="policiesSection">
          <h3 className="policiesSectionTitle">
            <span aria-hidden="true">{cat.icon}</span> <Trans i18nKey={cat.titleKey} />
          </h3>
          <div className="policiesGrid">
            {cat.policies.map((doc) => (
              <div key={doc.titleKey} className="policyCard">
                <h5 className="policyTitle"><Trans i18nKey={doc.titleKey} /></h5>
                <p className="policyYear">{doc.year}</p>
                <div className="policyButtons">
                  <button type="button" className="policyBtn policyBtnPrimary" onClick={() => setActiveDoc(doc)}>
                    <Trans i18nKey="Preview" />
                  </button>
                  <a className="policyBtn policyBtnOutline" href={doc.file} download>
                    <Trans i18nKey="Download" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}

      <Modal show={!!activeDoc} fullscreen onHide={() => setActiveDoc(null)}>
        <Modal.Header closeButton>
          <Modal.Title>{activeDoc ? <Trans i18nKey={activeDoc.titleKey} /> : null}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {activeDoc ? (
            <object data={activeDoc.file} type="application/pdf" width="100%" height="100%">
              {/* Shown on phones that cannot display PDFs inline */}
              <a href={activeDoc.file} target="_blank" rel="noreferrer">
                <Trans i18nKey="Download" />
              </a>
            </object>
          ) : null}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default MainBlockLayout(MainBlock);
